export const WidgetPlacement = {
  Sheet: 'sheet',
  Inline: 'inline',
} as const;
export type WidgetPlacement = typeof WidgetPlacement[keyof typeof WidgetPlacement];

export interface FollowUpInput {
  type: string;
  action: string;
  text?: string;
  value?: string;
  params?: Record<string, unknown>;
}

export const DEFAULT_SKIP_QUESTIONS: readonly string[] = ['followupIntroMessage'];
export const INLINE_COMPLETION_DISMISS_MS = 3000;
export const CLICK_FEEDBACK_LOCK_MS = 800;
export const ACTIVE_FOLLOWUP_CACHE_KEY = 'fupQuestionsActive';
export const COMPLETED_FOLLOWUP_CACHE_KEY = 'fupQuestionsCompleted';
